module.exports = __webpack_public_path__ + "static/img/fr.-johnson-iype-263x300.89c4550.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/profile/fr.-johnson-iype-263x300.jpg
// module id = MIyV
// module chunks = 0